module.exports = __webpack_public_path__ + "static/media/video-thumb-small.8ebd09af.svg";